import { observer } from 'owa-mobx-react';
import React from 'react';
import { continueGetDataFromParentWindow } from '../utils/getDataFromParentWindow';
import { getStore } from '../store/childStore';
import { isFeatureEnabled } from 'owa-feature-flags';
import { PopoutChildState } from '../store/schema/PopoutChildStore';
import { Spinner } from '@fluentui/react/lib/Spinner';

export interface PopoutLoadingViewProps {
    loadingString: string;
}

import { view } from './PopoutLoadingView.scss';

const defaultExport: React.FunctionComponent<PopoutLoadingViewProps> = observer(
    function PopoutLoadingView(props: PopoutLoadingViewProps) {
        React.useEffect(() => {
            if (!isFeatureEnabled('rp-popoutsDebug')) {
                loadData();
            }
        }, []);
        const renderSpinner = () => {
            return (
                <span>
                    <Spinner />
                    {props.loadingString}
                </span>
            );
        };
        return (
            <div className={view}>
                {getStore().state == PopoutChildState.Loading
                    ? renderSpinner()
                    : renderDebugButton()}
            </div>
        );
    },
    'PopoutLoadingView'
);
export default defaultExport;

function loadData() {
    continueGetDataFromParentWindow();
}

function renderDebugButton() {
    // This UI is only visible when rp-popoutsDebug flight is enabled, and is used for debugging only,
    // so no need to be localized
    /* eslint-disable-next-line react/button-has-type -- (https://aka.ms/OWALintWiki)
     * Baseline, DO NOT COPY-PASTE!, change this line with a justification or add proper type prop to the button between "button", "submit", or "reset" https://github.com/jsx-eslint/eslint-plugin-react/blob/master/docs/rules/button-has-type.md
     *	> Missing an explicit type attribute for button */
    return <button onClick={loadData}>Get Data</button>;
}
